/** Query keys of the web-gather provenance lookup (kept apart from the hook so writers can invalidate it). */
export const bbSourcesKeys = {
  list: (tenantId: string) => ['bb-sources', tenantId] as const,
};
